<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="4"
        >
          <base-material-card
            color="primary"
            icon="mdi-group"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Group Management
              </div>
            </template>
            <v-data-table
              :headers="groupheaders"
              :items="getcurrentgroups"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Groups</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialoggroup"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Group
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formGroupTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedGroupItem.name"
                                label="Name"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closegroup"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="savegroup"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.alerts`]="{ item }">
                {{ item.alerts }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                  color="primary"
                  size="20"
                  @click="editGroupItem(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteGroupItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No Groups to display
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
        <v-col
          sm="12"
          md="12"
          lg="8"
        >
          <base-material-card
            color="primary"
            icon="mdi-account-details-outline"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                User Management
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="currentusers"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Current Users</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />

                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />

                  <v-spacer />
                  <v-btn
                    color="warning"
                    dark
                    class="mb-2"
                    to="/"
                  >
                    Return
                  </v-btn>
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }" />
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.email"
                                label="Email"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-autocomplete
                                v-model="editedItem.group"
                                :items="grouplist"
                                label="Group"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-checkbox
                                v-model="editedItem.alerts"
                                :label="`Alerts Active: ${editedItem.alerts.toString()}`"
                              />
                            </v-col>

                            <v-col v-if="isdeposituser(editedItem.status)">
                              <v-select
                                v-model="editedItem.sitesfordep"
                                :items="sitelist"
                                attach
                                chips
                                label="Sites for Deposit"
                                multiple
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-select
                                v-model="editedItem.status"
                                :items="getavailablestatus"
                                label="Status"
                                @change="onChange($event)"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-select
                                v-model="editedItem.institution"
                                :items="getcurrentinst"
                                return-object
                                item-text="name"
                                label="Institutions"
                                @change="onChange($event)"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.alerts`]="{ item }">
                {{ item.alerts }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                  color="primary"
                  size="20"
                  @click="editItem(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No Users to display
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="yellow darken-2"
            icon="mdi-bank"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Institution Management
              </div>
            </template>
            <v-data-table
              :headers="instheaders"
              :items="getcurrentinst"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Institution</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialogInst"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Institution
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formInstTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedInstItem.name"
                                label="Name"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closeInst"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="saveInst"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.alerts`]="{ item }">
                {{ item.alerts }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                  color="primary"
                  size="20"
                  @click="editInstItem(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteInstItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No Institutions to display
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>
<script>
  // import moment from 'moment'

  // var numeral = require('numeral')

  export default {
    data () {
      return {
        newgroup: '',
        currentgroups: '',
        currentInst: '',
        snackbar: false,
        timeout: 5000,
        alertmessage: '',
        currentuser: this.$store.getters.user,
        dialog: false,
        dialoggroup: false,
        dialogInst: false,
        sitesfordep: [],
        switch1: true,
        headers: [
          { text: 'Email', value: 'email', align: 'left' },
          { text: 'Group', value: 'group', align: 'left' },
          { text: 'Status', value: 'status', align: 'left' },
          { text: 'Alerts Enabled', value: 'alerts', align: 'center' },
          { text: 'Actions', value: 'action', align: 'center' }
        ],
        groupheaders: [
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Actions', value: 'action', align: 'center' }
        ],
        instheaders: [
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Key', value: 'key', align: 'left' },
          { text: 'Actions', value: 'action', align: 'center' }
        ],
        editedGroupIndex: -1,
        editedGroupItem: {
          name: '',
          key: ''
        },
        defaultGroupItem: {
          name: '',
          key: ''
        },
        editedInstIndex: -1,
        editedInstItem: {
          name: '',
          key: ''
        },
        defaultInstItem: {
          name: '',
          key: ''
        },
        editedIndex: -1,
        editedItem: {
          group: '',
          alerts: false,
          sitesfordep: null,
          status: '',
          level: '',
          email: '',
          institution: ''
        },
        defaultItem: {
          group: '',
          alerts: false,
          status: '',
          sitesfordep: null,
          level: '',
          email: '',
          institution: ''
        },
        search: '',
        expand: false,
        title: 'User Management',
        icon: 'dashboard',
        authUser: '',
        users: []
      }
    },
    computed: {
      getcurrentinst () {
        this.currentInst = []
        this.currentInst = this.$store.getters.userinstitutions
        return this.currentInst
      },
      getcurrentgroups () {
        this.$log.debug('groups', this.$store.getters.usergroups)
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },
      statuslist () {
        return ['groupmanager', 'vieweronly', 'deposituser']
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      currentusers () {
        this.users = this.$store.getters.userprofiles
        return this.users
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New User Profile' : 'Edit User Profile'
      },
      formGroupTitle () {
        return this.editedGroupIndex === -1 ? 'New Group' : 'Edit Group'
      },
      formInstTitle () {
        return this.editedInstIndex === -1 ? 'New Institution' : 'Edit Institution'
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      checkupdates () {
        // this.$store.dispatch('intitrealtimeupdates')
      },
      sitelist () {
        let sites = this.$store.getters.loadedSites
        this.$log.debug(' dep site sites ', sites)
        return sites.map(st => st.idnum)
      },
      getavailablestatus (user) {
        let statuses = ''
        if (this.$store.getters.user.status === 'deposituser') {
          // they can do nothing
          return statuses
        } else if (this.$store.getters.user.status === 'vieweronly') {
          // nothing they can do
          return statuses
        } else if (this.$store.getters.user.status === 'storemanager') {
          statuses = ['vieweronly', 'deposituser', 'storemanager']
          return statuses
        } else if (this.$store.getters.user.status === 'groupmanager') {
          statuses = ['vieweronly', 'deposituser', 'storemanager', 'groupmanager']
          return statuses
        } else if (this.$store.getters.user.status === 'corporate') {
          statuses = ['vieweronly', 'deposituser', 'storemanager', 'groupmanager', 'corporate']
          return statuses
        } else if (this.$store.getters.user.status === 'admin') {
          statuses = ['vieweronly', 'deposituser', 'storemanager', 'groupmanager', 'corporate']
          return statuses
        }
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialoggroup (val) {
        val || this.close()
      },
    },
    created () {
      this.$store.dispatch('loadUserProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadUserInstitutions')

      this.users = this.$store.getters.userprofiles
      this.$log.debug('our loaded usrs are ', this.users)
    },
    methods: {
      onChange (statuslabel) {
        console.log('changed ', statuslabel)
        this.$log.debug(statuslabel)

        this.$log.debug('level is now ', this.editedItem.level)
      },
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      isdeposituser (user) {
        if (user === 'deposituser') {
          return true
        }
        return false
      },
      isadmin (user) {
        if (user === 'admin') {
          return true
        }
        return false
      },
      addgroup () {
        this.$log.debug('want to add group ', this.newgroup)
        if (this.newgroup) {
          // this.currentgroups.push(this.newgroup)
          this.$log.debug('I am adding group ', this.newgroup)
          this.$store.dispatch('createUserGroup', this.newgroup)
          // make sure to load on a good add to the db
          this.$store.dispatch('loadUserGroups')
          this.newgroup = ''
        }
      },
      editInstItem (item) {
        this.editedInstIndex = this.currentInst.indexOf(item)
        this.editedInstItem = Object.assign({}, item)
        this.dialogInst = true
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        let grpdetails = this.$store.getters.usergroups.find(group => group.name === this.currentgroups[index])
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editGroupItem (item) {
        this.$log.debug('hit edit group item')
        this.editedGroupIndex = this.currentgroups.indexOf(item)
        this.editedGroupItem = Object.assign({}, item)
        this.dialoggroup = true
      },
      deleteGroupItem (profile) {
        this.currentgroups = this.$store.getters.usergroups
        const index = this.currentgroups.indexOf(profile)
        let grpdetails = this.$store.getters.usergroups.find(group => group.name === this.currentgroups[index])
        if (confirm('Are you sure you want to delete this group?') && this.currentgroups.splice(index, 1)) {
          this.$store.dispatch('removeUserGroup', profile)
          this.$store.dispatch('loadUserGroups')
          // this.$store.dispatch('removeUserProfile', profile)
          // this.$store.dispatch('loadUserProfiles')
        }
      },
      editItem (item) {
        // populate their institutional status

        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (profile) {
        this.users = this.$store.getters.userprofiles
        const index = this.users.indexOf(profile)
        if (confirm('Are you sure you want to delete this user?') && this.users.splice(index, 1)) {
          this.$store.dispatch('removeUserProfile', profile)
          this.$store.dispatch('loadUserProfiles')
        }
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      closeInst () {
        this.dialogInst = false
        setTimeout(() => {
          this.editedInstItem = Object.assign({}, this.defaultInstItem)
          this.editedInstIndex = -1
        }, 300)
      },
      saveInst () {
        let instlist = this.$store.getters.userinstitutions.map(
          inst => inst.name
        )
        if (instlist.includes(this.editedInstItem.name)) {
          this.alertmessage = 'This Institution name already exists'
          this.snackbar = true
          this.closeInst()
          return
        }
        this.$log.debug('institution to edit was ', this.editedInstItem)
        const instData = {
          name: this.editedInstItem.name,
          key: this.editedInstItem.key,
          sitekeys: []
        }
        if (this.editedInstIndex > -1) {
          this.$store.dispatch('updateInstitutions', instData)
          // this.$store.dispatch('updateUserProfile', userData)
          Object.assign(this.currentInst[this.editedInstIndex], this.editedInstItem)
        } else {
          this.$log.debug('there is no else')
          this.$store.dispatch('createUserInstitutions', instData.name)
        }
        this.$store.dispatch('loadUserInstitutions')
        this.closeInst()
      },
      closegroup () {
        this.dialoggroup = false
        setTimeout(() => {
          this.editedGroupItem = Object.assign({}, this.defaultGroupItem)
          this.editedGroupIndex = -1
        }, 300)
      },
      savegroup () {
        let groupslist = this.$store.getters.usergroups.map(
          group => group.name
        )
        if (groupslist.includes(this.editedGroupItem.name)) {
          this.alertmessage = 'This group name already exists'
          this.snackbar = true
          this.closegroup()
          return
        }
        this.$log.debug('group to edit was ', this.editedGroupItem)
        const groupData = {
          name: this.editedGroupItem.name,
          key: this.editedGroupItem.groupkey,
        }
        if (this.editedGroupIndex > -1) {
          this.$store.dispatch('updateGroup', groupData)
          // this.$store.dispatch('updateUserProfile', userData)
          Object.assign(this.currentgroups[this.editedGroupIndex], this.editedGroupItem)
        } else {
          this.$log.debug('there is no else')
          this.$store.dispatch('createUserGroup', groupData.name)
        }
        this.$store.dispatch('loadUserGroups')
        this.closegroup()
      },
      save () {
        this.$log.debug('dep sites ', this.editedItem)
        if (this.editedItem.status === 'deposituser') {
          // they can do nothing
          this.editedItem.level = 100
        } else if (this.editedItem.status === 'vieweronly') {
          // nothing they can do
          this.editedItem.level = 100
        } else if (this.editedItem.status === 'storemanager') {
          this.editedItem.level = 200
        } else if (this.editedItem.status === 'groupmanager') {
          this.editedItem.level = 300
        } else if (this.editedItem.status === 'corporate') {
          this.editedItem.level = 400
        } else if (this.editedItem.status === 'admin') {
          this.editedItem.level = 500
        }
        let inst = {
          name: null,
          key: null
        }
        if (this.editedItem.institution) {
          inst.name = this.editedItem.institution.name
          inst.key = this.editedItem.institution.key
        }
        const userData = {
          email: this.editedItem.email,
          alerts: this.editedItem.alerts,
          sitesfordep: this.editedItem.sitesfordep,
          userkey: this.editedItem.userkey,
          group: this.editedItem.group,
          level: this.editedItem.level,
          status: this.editedItem.status,
          bio: this.editedItem.bio,
          institution: inst
        }
        if (this.editedIndex > -1) {
          console.log('updaing user data ', userData)
          this.$store.dispatch('updateUserProfile', userData)
          Object.assign(this.users[this.editedIndex], this.editedItem)
        } else {
          this.$log.debug('there is no else')
        }
        this.$store.dispatch('loadUserProfiles')
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
